import React, { useState, useEffect } from "react";
import "../refinance/remaining-balance.css";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import { stepStyles } from "../formStyles";

export const ProjectBudget = ({ formData, setForm, navigation, step }) => {
  const [priceInputValue, setpriceInputValue] = useState(0);
  const [priceInput] = useState({
    0: "0",
    1: "125,000",
    2: "150,000",
    3: "200,000",
    4: "250,000",
    5: "300,000",
    6: "350,000",
    7: "400,000",
    8: "450,000",
    9: "500,000",
    10: "550,000",
    11: "600,000",
    12: "650,000",
    13: "700,000",
    14: "750,000",
    15: "800,000",
    16: "850,000",
    17: "900,000",
    18: "950,000",
    19: "1,000,000",
    20: "1,050,000",
    21: "1,100,000",
    22: "1,150,000",
    23: "1,200,000",
    24: "1,250,000",
    25: "1,300,000",
    26: "1,350,000",
    27: "1,400,000",
    28: "1,450,000",
    29: "1,500,000",
    30: "1,550,000",
    31: "1,600,000",
    32: "1,650,000",
    33: "1,700,000",
    34: "1,750,000",
    35: "1,800,000",
    36: "1,850,000",
    37: "1,900,000",
    38: "1,950,000",
    39: "2,000,000",
    40: "2,050,000",
    41: "2,100,000",
    42: "2,150,000",
    43: "2,200,000",
    44: "2,250,000",
    45: "2,300,000",
    46: "2,350,000",
    47: "2,400,000",
    48: "2,450,000",
    49: "2,500,000",
    50: "2,600,000",
    51: "2,700,000",
    52: "2,800,000",
    53: "2,900,000",
    54: "3,000,000",
  });

  const [isVisible] = useState(true);
  const [error, setError] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const slider = React.createRef();
  const sliderValue = React.createRef();
  console.log(priceInput[priceInputValue]);
  useEffect(() => {
    slider.current.setAttribute("min", 0);
    slider.current.setAttribute("max", Object.keys(priceInput).length - 1);
    const thumbSize = parseInt(window.getComputedStyle(sliderValue.current).getPropertyValue("--thumb-size"), 10);
    handleSliderValuePosition(slider.current, thumbSize);
  }, [priceInputValue]);

  const handlePricingSlide = (e) => {
    setpriceInputValue(e.target.value);
    handleSliderValuePosition(e.target);
    setError(false);
  };

  useEffect(() => {
    formData.projectBudget = priceInput[priceInputValue];
  }, [priceInputValue]);

  const handleSliderValuePosition = (input, thumbSize) => {
    const multiplier = input.value / input.max;
    const thumbOffset = thumbSize * multiplier;
    const priceInputOffset = (thumbSize - sliderValue.current.clientWidth) / 2;
    sliderValue.current.style.left = input.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
  };
  const handleNextAndSubmit = () => {
    if (formData.projectBudget === "0") {
      return setError(true);
    }
    setError(false);
    navigation.next();
  };

  return (
    <div className={stepStyles.page}>
      <div className="w-full">
        <ProgressBar width={"50%"} />
        <div className={stepStyles.content}>
          {transition((style, item) =>
            item ? (
              <animated.div style={style} className={stepStyles.panel}>
                <h1 className={stepStyles.title}>What is your project budget?</h1>
                <div className="pricing">
                  <div className="pricing-slider center-content">
                    <label className="form-slider">
                      <input
                        type="range"
                        ref={slider}
                        defaultValue={priceInputValue}
                        onChange={handlePricingSlide}
                        name="homeValue"
                      />
                    </label>
                  </div>
                  <div ref={sliderValue} className="pricing-slider-value">
                    <h2 className={stepStyles.sliderValue}>${priceInput[priceInputValue]}</h2>
                  </div>
                </div>
                {error ? <div className={stepStyles.sliderError}>Please select a budget</div> : null}
              </animated.div>
            ) : null,
          )}
        </div>
      </div>
      <div className={stepStyles.actionBar}>
        <div className={stepStyles.actionRow}>
          <div className="w-full md:w-auto">
            <button className={`${stepStyles.button} w-full`} onClick={() => handleNextAndSubmit()}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectBudget;
